/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,
  
} from '@thd-olt-component-react/fusion-utils';







  import { PIPRedirector }
    from "@thd-nucleus/app-render";
  
  export { PIPRedirector }

  import { ProductMetadata }
    from "@thd-olt-component-react/metadata";
  
  export { ProductMetadata }

  import { PIPStickyNav }
    from "@thd-olt-component-react/sticky-nav";
  
  export { PIPStickyNav }

  import { Breadcrumbs }
    from "@thd-olt-component-react/breadcrumbs";
  
  export { Breadcrumbs }

  import { ProductInfoBar }
    from "@thd-olt-component-react/product-info-bar";
  
  export { ProductInfoBar }

  import { DynamicRecsWrapperPip }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { DynamicRecsWrapperPip }

  import { Discontinued }
    from "@thd-olt-component-react/discontinued";
  
  export { Discontinued }

  import { MediaGalleryHorizontalWithHotspots }
    from "@thd-olt-component-react/media-gallery";
  
  export { MediaGalleryHorizontalWithHotspots }

  import { Avataar }
    from "@thd-olt-component-react/augmented-reality";
  
  export { Avataar }

  import { RoomVo }
    from "@thd-olt-component-react/augmented-reality";
  
  export { RoomVo }

  import { ProductPageEventCountdownTimer }
    from "@thd-olt-component-react/event-countdown-timer";
  
  export { ProductPageEventCountdownTimer }

  import { PIPProductDetails }
    from "@thd-olt-component-react/product-details";
  
  export { PIPProductDetails }

  import { PIPPriceClearanceWrapper }
    from "@thd-olt-component-react/price";
  
  export { PIPPriceClearanceWrapper }

  import { Promotion }
    from "@thd-olt-component-react/promotion";
  
  export { Promotion }

  import { ConsumerCardMessaging }
    from "@thd-olt-component-react/consumer-card-messaging";
  
  export { ConsumerCardMessaging }

  import { PromotionProductsAnchor }
    from "@thd-olt-component-react/promotion-products";
  
  export { PromotionProductsAnchor }

  import { PIPSalientPoints }
    from "@thd-olt-component-react/salient-points";
  
  export { PIPSalientPoints }

  import { AisleBay }
    from "@thd-olt-component-react/aisle-bay";
  
  export { AisleBay }

  import { ConfiguratorAndPipFlipLayout }
    from "@thd-olt-component-react/product-configurator";
  
  export { ConfiguratorAndPipFlipLayout }

  import { SuperSku }
    from "@thd-olt-component-react/super-sku";
  
  export { SuperSku }

  import { FitCompatibility }
    from "@thd-olt-component-react/fit-compatibility";
  
  export { FitCompatibility }

  import { MajorApplianceBuyBox }
    from "@thd-olt-component-react/buybox";
  
  export { MajorApplianceBuyBox }

  import { GlobalCustomConfigurator }
    from "@thd-olt-component-react/global-custom-configurator";
  
  export { GlobalCustomConfigurator }

  import { CompatibleAccessories }
    from "@thd-olt-component-react/compatible-accessories";
  
  export { CompatibleAccessories }

  import { BundlePmvFbtLayoutMa }
    from "@thd-olt-component-react/bundle-mini";
  
  export { BundlePmvFbtLayoutMa }

  import { ProductOverviewAccordionTitle }
    from "@thd-olt-component-react/product-overview";
  
  export { ProductOverviewAccordionTitle }

  import { SpecificationsAccordionTitle }
    from "@thd-olt-component-react/specifications";
  
  export { SpecificationsAccordionTitle }

  import { QuestionsAndAnswersAccordionTitle }
    from "@thd-olt-component-react/questions-and-answers";
  
  export { QuestionsAndAnswersAccordionTitle }

  import { RatingsAndReviewsAccordionTitle }
    from "@thd-olt-component-react/ratings-and-reviews";
  
  export { RatingsAndReviewsAccordionTitle }

  import { BazaarVoiceCarousel }
    from "@thd-olt-component-react/social-media-container";
  
  export { BazaarVoiceCarousel }

  import { RoomVoInspire }
    from "@thd-olt-component-react/augmented-reality";
  
  export { RoomVoInspire }

  import { SponsoredPipBanner }
    from "@thd-olt-component-react/sponsored-content";
  
  export { SponsoredPipBanner }

  import { WhatWeOffer }
    from "@thd-olt-component-react/what-we-offer";
  
  export { WhatWeOffer }

  import { DeliveryAndInstallation }
    from "@thd-olt-component-react/delivery-and-installation";
  
  export { DeliveryAndInstallation }

  import { RetailMediaCarouselFusionPIP }
    from "@thd-olt-component-react/retail-media-pla-sponsored-placements";
  
  export { RetailMediaCarouselFusionPIP }

  import { RecentlyViewedWrapper }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { RecentlyViewedWrapper }

  import { RelatedSearch }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedSearch }

  import { RelatedProducts }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedProducts }

  import { PopularVariations }
    from "@thd-olt-component-react/related-search";
  
  export { PopularVariations }






import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsWithKPFAccordionBody as SpecificationsWithKPFAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { FeatureBasedRecommendationsImporterVite as FeatureBasedRecommendationsImporterViteSSR } from '@thd-olt-component-react/feature-based-recommendations?clientSideRemove';

import { EmtLinks as EmtLinksSSR } from '@thd-olt-component-react/emt-links?clientSideRemove';



  
    
      
        const SlotA1 = withLayout(
          [
            
              PIPRedirector,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotA2 = withLayout(
          [
            
              ProductMetadata,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotA3 = withLayout(
          [
            
              PIPStickyNav,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotB1 = withLayout(
          [
            
              Breadcrumbs,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotC1 = withLayout(
          [
            
              ProductInfoBar,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD1 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD2 = withLayout(
          [
            
              Discontinued,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE1 = withLayout(
          [
            
              MediaGalleryHorizontalWithHotspots,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE2 = withLayout(
          [
            
              Avataar,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE3 = withLayout(
          [
            
              RoomVo,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF1 = withLayout(
          [
            
              ProductPageEventCountdownTimer,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF2 = withLayout(
          [
            
              PIPProductDetails,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF3 = withLayout(
          [
            
              PIPPriceClearanceWrapper,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF4 = withLayout(
          [
            
              Promotion,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF5 = withLayout(
          [
            
              ConsumerCardMessaging,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF6 = withLayout(
          [
            
              PromotionProductsAnchor,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF7 = withLayout(
          [
            
              PIPSalientPoints,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF8 = withLayout(
          [
            
              AisleBay,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF9 = withLayout(
          [
            
              ConfiguratorAndPipFlipLayout,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF10 = withLayout(
          [
            
              SuperSku,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF11 = withLayout(
          [
            
              FitCompatibility,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF12 = withLayout(
          [
            
              MajorApplianceBuyBox,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF13 = withLayout(
          [
            
              GlobalCustomConfigurator,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF14 = withLayout(
          [
            
              CompatibleAccessories,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG1 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG2 = withLayout(
          [
            
              BundlePmvFbtLayoutMa,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG3 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  

  

  

  
    
      
        const SlotG7 = withLayout(
          [
            
              BazaarVoiceCarousel,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG8 = withLayout(
          [
            
              RoomVoInspire,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG9 = withLayout(
          [
            
              SponsoredPipBanner,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG10 = withLayout(
          [
            
              WhatWeOffer,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG11 = withLayout(
          [
            
              DeliveryAndInstallation,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG12 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG13 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG14 = withLayout(
          [
            
              RetailMediaCarouselFusionPIP,
            
          ],
          
        );
      
    
  

  

  
    
      
        const SlotG16 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG17 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG18 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG19 = withLayout(
          [
            
              RecentlyViewedWrapper,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG20 = withLayout(
          [
            
              RelatedSearch,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG21 = withLayout(
          [
            
              RelatedProducts,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG22 = withLayout(
          [
            
              PopularVariations,
            
          ],
          
        );
      
    
  

  



const ssr = typeof window === 'undefined';


  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  
    


    
      
        const SlotG4Index0DataModel = ssr
        ? BotPromptSSR
        : {};

      
    
  

  
  
    
      
      
        
          const SlotG5Index0DataModelK0 = ssr
          ? ProductOverviewAccordionTitleSSR
          : {};
        
        
        
          const SlotG5Index0DataModelBodyK0 = ssr
          ? ProductOverviewAccordionBodySSR
          : {};
        
      
        
          const SlotG5Index1DataModelK0 = ssr
          ? SpecificationsAccordionTitleSSR
          : {};
        
        
        
          const SlotG5Index1DataModelBodyK0 = ssr
          ? SpecificationsWithKPFAccordionBodySSR
          : {};
        
      
        
          const SlotG5Index2DataModelK0 = ssr
          ? QuestionsAndAnswersAccordionTitleSSR
          : {};
        
        
        
          const SlotG5Index2DataModelBodyK0 = ssr
          ? QuestionsAndAnswersAccordionBodySSR
          : {};
        
      
        
          const SlotG5Index3DataModelK0 = ssr
          ? RatingsAndReviewsAccordionTitleSSR
          : {};
        
        
        
          const SlotG5Index3DataModelBodyK0 = ssr
          ? RatingsAndReviewsAccordionBodySSR
          : {};
        
      
    


    
  

  
  
    


    
      
        const SlotG6Index0DataModel = ssr
        ? BotPromptSSR
        : {};

      
    
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  
    


    
      
        const SlotG15Index0DataModel = ssr
        ? FeatureBasedRecommendationsImporterViteSSR
        : {};

      
    
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  
    


    
      
        const SlotG23Index0DataModel = ssr
        ? EmtLinksSSR
        : {};

      
    
  



export {
  
  
    
      SlotA1,
    
  
    
      SlotA2,
    
  
    
      SlotA3,
    
  
    
      SlotB1,
    
  
    
      SlotC1,
    
  
    
      SlotD1,
    
  
    
      SlotD2,
    
  
    
      SlotE1,
    
  
    
      SlotE2,
    
  
    
      SlotE3,
    
  
    
      SlotF1,
    
  
    
      SlotF2,
    
  
    
      SlotF3,
    
  
    
      SlotF4,
    
  
    
      SlotF5,
    
  
    
      SlotF6,
    
  
    
      SlotF7,
    
  
    
      SlotF8,
    
  
    
      SlotF9,
    
  
    
      SlotF10,
    
  
    
      SlotF11,
    
  
    
      SlotF12,
    
  
    
      SlotF13,
    
  
    
      SlotF14,
    
  
    
      SlotG1,
    
  
    
      SlotG2,
    
  
    
      SlotG3,
    
  
    
  
    
  
    
  
    
      SlotG7,
    
  
    
      SlotG8,
    
  
    
      SlotG9,
    
  
    
      SlotG10,
    
  
    
      SlotG11,
    
  
    
      SlotG12,
    
  
    
      SlotG13,
    
  
    
      SlotG14,
    
  
    
  
    
      SlotG16,
    
  
    
      SlotG17,
    
  
    
      SlotG18,
    
  
    
      SlotG19,
    
  
    
      SlotG20,
    
  
    
      SlotG21,
    
  
    
      SlotG22,
    
  
    
  

  
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
      
      

      
        
          SlotG4Index0DataModel,
        
      
    
  
    
      
      
        
          
          
            SlotG5Index0DataModelK0,
          
          
          
            SlotG5Index0DataModelBodyK0,
          
        
          
          
            SlotG5Index1DataModelK0,
          
          
          
            SlotG5Index1DataModelBodyK0,
          
        
          
          
            SlotG5Index2DataModelK0,
          
          
          
            SlotG5Index2DataModelBodyK0,
          
        
          
          
            SlotG5Index3DataModelK0,
          
          
          
            SlotG5Index3DataModelBodyK0,
          
        
      

      
    
  
    
      
      

      
        
          SlotG6Index0DataModel,
        
      
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
      
      

      
        
          SlotG15Index0DataModel,
        
      
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
      
      

      
        
          SlotG23Index0DataModel,
        
      
    
  

};